import { getApiDomainFromHostname, reassignUrlDomain } from '@percent/utility'
import { env } from '@percent/partner-dashboard/env'

export const environment = env.NX_PUBLIC_REACT_APP_ENV

const DEFAULT_TEST_API_URL = 'http://localhost:8080/'
const DEFAULT_TEST_APP_URL = 'https://localhost:3000'

const envConfig = (() => {
  const obj = {
    urls: {
      api: '',
      app: ''
    },
    keys: {
      ga: '',
      recaptchaSiteKey: env.NX_PUBLIC_RECAPTCHA_SITE_KEY ?? '',
      geolocation: env.NX_PUBLIC_REACT_APP_GEOLOCATION_API_KEY ?? ''
    }
  }

  const appDomain = getApiDomainFromHostname()

  if (env.NX_PUBLIC_TEST_MODE === true) {
    obj.urls.api = `${DEFAULT_TEST_API_URL}`
    obj.urls.app = `${DEFAULT_TEST_APP_URL}`
  } else {
    obj.urls.api = `${reassignUrlDomain(env.NX_PUBLIC_API_URL, appDomain)}/`
    obj.urls.app = `${reassignUrlDomain(env.NX_PUBLIC_APP_URL, appDomain)}`
  }

  return obj
})()

export const config = {
  ...envConfig,
  version: '1.0.0'
}
